<template>
  <div class="col-option">
    <div v-if="columnProperties.field.column_property.display_type == 1">
      <div
        class="option-word"
        :style="styleProperty"
        :class="{ 'have-badge': checkBadge }"
      >
        {{
          renderValue
            ? $i18n.locale == 'th'
              ? renderValue.name_th
              : renderValue.name_en
            : ''
        }}
      </div>
    </div>
    <div v-if="columnProperties.field.column_property.display_type == 2">
      <div class="text-nowrap">
        <img
          v-if="renderValue.image"
          class="option-icon-have-img"
          :src="renderValue.image"
          alt=""
          draggable="false"
        >
        <feather-icon
          v-else-if="renderValue.icon"
          :icon="renderValue.icon"
          size="24"
          :style="{
            color: renderValue.icon_color,
          }"
        />
        <div
          class="option-word mt-5px px-1"
          :style="styleProperty"
          :class="{ 'have-badge': checkBadge }"
        >
          {{
            renderValue
              ? $i18n.locale == 'th'
                ? renderValue.name_th
                : renderValue.name_en
              : ''
          }}
        </div>
      </div>
    </div>
    <div v-if="columnProperties.field.column_property.display_type == 3">
      <div class="text-nowrap">
        <img
          v-if="renderValue.image"
          class="option-icon-have-img"
          :src="renderValue.image"
          alt=""
          draggable="false"
        >
        <feather-icon
          v-else-if="renderValue.icon"
          :icon="renderValue.icon"
          size="24"
          :style="{
            color: renderValue.icon_color,
          }"
        />
        <div
          v-else
          class="option-icon-not-item"
        >
          -
        </div>
      </div>
    </div>
    <div v-if="columnProperties.field.column_property.display_type == 4">
      <div class="d-flex align-items-center">
        <feather-icon
          icon="CircleIcon"
          size="7.94"
          :style="{
            color: renderValue.icon_color,
            fill: renderValue.icon_color,
          }"
          class="mr-2"
        />

        <span
          :style="{
            color: renderValue.color_font,
            fontSize: renderValue.font_size,
          }"
        >
          {{
            renderValue
              ? $i18n.locale == 'th'
                ? renderValue.name_th
                : renderValue.name_en
              : ''
          }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { optionColumn } from '@/configs/dynamic-config/dynamic-column'
import { computed, onBeforeMount, ref } from '@vue/composition-api'

export default {
  props: {
    columnProperties: Object,
  },
  setup(props) {
    const optionItem = ref({})

    const styleProperty = computed(() => ({
      color: optionItem?.value?.color_font || optionColumn.value.color_font,
      backgroundColor: optionItem?.value?.color_badge
        ? optionItem.value.color_badge
        : optionItem?.value?.color_bg || optionColumn.value.color_badge,
      fontSize: optionItem?.value?.font_size || optionColumn.value.font_size,
    }))

    const checkBadge = computed(() => (!!optionItem?.value?.color_badge))

    const renderValue = computed(() => (
        props.columnProperties.field.column_property.value?.find(o => o.value == props.columnProperties.value) || ''
    ))

    onBeforeMount(() => {
      if (props.columnProperties.field.column_property.value) {
        optionItem.value = props.columnProperties.field.column_property.value.find(
          o => o.value == props.columnProperties.value,
        )
      }
    })

    return {
      styleProperty,
      optionItem,
      checkBadge,
      renderValue,
    }
  },
}
</script>

<style scoped>
.col-option {
  display: inline-block;
}

.have-badge {
  padding: 0.3rem 0.5rem;
  border-radius: 10rem;
  text-align: center;
  text-transform: capitalize;
  font-size: 85%;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  vertical-align: baseline;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, background 0s,
    border 0s;
}

.option-icon-not-item {
  font-size: 24px;
}

.option-icon-have-img {
  width: 24px;
}

.mt-5px {
  margin-top: 5px;
}
.option-word {
  border-radius: 0.5rem;
}
</style>
